import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { profile } from 'stores/ProfileStore';

const en = require('./locales/en/translation-en.json');
const ja = require('./locales/ja/translation-ja.json');

const resources = {
  en: {
    translation: en,
  },
  ja: {
    translation: ja,
  },
};

async function detectLanguage() {
  await profile.ensureDataAvailability();

  localStorage.i18nextLng = profile.preferredLanguage || localStorage.i18nextLng || 'en';
  return localStorage.i18nextLng;
}

export const initI18n = async () => {
  i18n.use(initReactI18next).init({
    resources,
    lng: await detectLanguage(),
    fallbackLng: 'en',

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });
};
